import React from 'react';

export default function CardTeamWrapper({ children, title }) {
  return (
    <section className="mt-8">
      <h1 className="mb-8 text-4xl font-bold text-gray-400">{title}</h1>
      <section className="grid grid-cols-1 gap-10 mt-4 md:grid-cols-4">
        {children}
      </section>
    </section>
  );
}
